import React from 'react';

const footer = (props ) => {
   
    return(
        <footer className={[props.classes].join(' ')}>
            {  
              React.Children.map(props.children, child => {
               
                if(child.props.name==="toggleMenu" && child.type.name==="clickableIcon"){    
                    return React.cloneElement(child, {
                        action: props.onToggleMenu
                    })
                }else{
                    return React.cloneElement(child) 
                }
              })
            }
            {/* props.children */}
        </footer>
    );
}

export default footer;


// WEBPACK FOOTER //
// ./src/containers/Navigation/Footer/Footer.js